import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import { PayPalButtons } from "@paypal/react-paypal-js";

import { useAuth } from "./auth/useAuth";

// const Paypal = ({ targetPlanId, onApprove, onError }) => {
//   useEffect(() => {
//     if (open) {
//       window.paypal
//         .Buttons({
//           createSubscription: (data, actions) => {
//             return actions.subscription
//               .revise("I-8D8L0MMBCMUC", {
//                 plan_id: targetPlanId,
//               })
//               .then((orderId) => {
//                 // Your code here after create the order
//                 return orderId;
//               });
//           },
//           onApprove,
//           onError,
//         })
//         .render("#paypal-button-container");
//     }
//   }, [open]);

//   return <></>;
// };

enum Mode {
  Initial,
  Confirm,
  Success,
  Error,
}

const useChangePlanDialog = () => {
  const [mode, setMode] = React.useState(Mode.Initial);
  const [open, setOpen] = React.useState(false);
  const [targetPlanId, setTargetPlanId] = React.useState<string>();
  const [consentUrl, setConsentUrl] = React.useState<string>();

  const { userAdditionalData } = useAuth();

  const subscriptionId = userAdditionalData?.activeSubscription?.subscriptionId;
  const subscriberEmail = userAdditionalData?.email;

  const handleClose = () => {
    setMode(Mode.Initial);
    setOpen(false);
  };

  const initial = mode === Mode.Initial;
  const confirm = mode === Mode.Confirm;
  const success = mode === Mode.Success;
  const error = mode === Mode.Error;

  const handleConfirm = () => {
    setMode(Mode.Confirm);
  };

  return {
    openChangePlanDialog: (targetPlanId) => {
      setTargetPlanId(targetPlanId);
      setOpen(true);
      // reviseSubscription({ planId: targetPlanId })
      //   .then((data: any) => {
      //     setMode(Mode.Confirm);
      //     console.log("data", data.data.confirmationUrl);

      //     setConsentUrl(data.data.confirmationUrl);
      //   })
      //   .catch(() => {
      //     setMode(Mode.Error);
      //   });
    },
    Dialog: (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          {initial && (
            <>
              <Typography sx={{ marginTop: 2, marginBottom: 3 }} align="center">
                Para fazer a mudança de plano, clique no botão do PayPal:
              </Typography>

              <div id="paypal-button-container">
                {/* <Paypal
                  targetPlanId={targetPlanId}
                  onApprove={async (data, actions) => {
                    console.log("onapprove", data);
                    setMode(Mode.Success);
                    // updateUserAdditionalData();
                    return;
                  }}
                  onError={(error) => {
                    setMode(Mode.Error);
                  }}
                /> */}
                {subscriptionId ? (
                  <PayPalButtons
                    style={{ layout: "horizontal" }}
                    createSubscription={(data, actions) => {
                      return actions.subscription
                        .revise(subscriptionId, {
                          plan_id: targetPlanId,
                        })
                        .then((orderId) => {
                          // Your code here after create the order

                          return orderId;
                        });
                    }}
                    onApprove={async (data, actions) => {
                      setMode(Mode.Success);
                      // updateUserAdditionalData();
                      return;
                    }}
                  />
                ) : (
                  "Não foi identificada uma inscrição vigente."
                )}
              </div>

              {/* <Box marginX={2}>
                <PayPalButtons
                  style={{ layout: "horizontal" }}
                  createSubscription={(data, actions) => {
                    console.log("createSubscription data", data);

                    // @ts-ignore
                    return actions.subscription
                      .revise('I-8D8L0MMBCMUC', {
                        plan_id: targetPlanId,
                      })
                      .then((orderId) => {
                        // Your code here after create the order
                        console.log("orderId", orderId);

                        return orderId;
                      });
                  }}
                  onApprove={async (data, actions) => {
                    console.log("onapprove", data);
                    setMode(Mode.Success);
                    // updateUserAdditionalData();
                    return;
                  }}
                />
              </Box> */}
            </>
          )}

          {/* {confirm && (
            <>
              <Typography sx={{ marginTop: 2, marginBottom: 3 }} align="center">
                Clique no botão abaixo para confirmar a mudança de plano junto ao Paypal
              </Typography>

              <Box marginX={2} display="flex" justifyContent="center">
                <Button
                  onClick={() => {
                    console.log("opening consent", consentUrl);

                    window.open(consentUrl, "consentSubscriptionPlanChange", "popup");
                  }}
                  variant="contained"
                  color="primary"
                >
                  Confirmar mudança de plano
                </Button>
              </Box>
            </>
          )} */}

          {success && (
            <>
              <Typography sx={{ marginTop: 2, marginBottom: 3 }} align="center">
                Concluído! Assim que recebermos a confirmação do Paypal seu plano será atualizado.
              </Typography>
            </>
          )}

          {error && (
            <>
              <Typography sx={{ marginTop: 2 }} align="center">
                Algo deu errado :(
              </Typography>

              <Typography sx={{ marginBottom: 3 }} align="center">
                Tente novamente ou entre em contato conosco
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>

          {/* {initial && (
            <Button
              onClick={() => {
                handleConfirm();
              }}
              variant="contained"
              color="primary"
            >
              Sim!
            </Button>
          )} */}
        </DialogActions>
      </Dialog>
    ),
  };
};

export { useChangePlanDialog };
